"use client";

import { useSpotUser } from "@/app/_components/conditions/SpotUserProvider";

// Crew join CTA for a conditions detail page. The page is statically
// rendered for everyone, so the card always exists in the HTML; members
// see it removed after the per-user fetch resolves.

type Props = {
  slug: string;
  destinationName: string;
  memberCount: number;
};

export function CrewJoinCard({ slug, destinationName, memberCount }: Props) {
  const { isCrewMember } = useSpotUser();

  if (isCrewMember) return null;

  return (
    <section className="max-w-[1100px] mx-auto px-5 md:px-12 pb-6 md:pb-8">
      <a
        href={`/community/crew/${slug}`}
        className="block bg-gradient-to-br from-navy/[0.03] to-navy/[0.01] border border-border-light rounded-[16px] p-5 md:p-7 text-center no-underline hover:border-navy/20 transition-colors"
      >
        <p className="text-[14px] text-text-body">
          Join the <span className="font-semibold text-navy">{destinationName}</span> crew to see what{" "}
          {memberCount > 0 ? `${memberCount} seasonaires and locals are` : "others are"} reporting
        </p>
        <span className="inline-block mt-2 text-[13px] font-semibold text-navy">
          View crew →
        </span>
      </a>
    </section>
  );
}
